import React from 'react';

class SectionDivider extends React.Component {
  render() {
    return (
      <div className="divider-wrapper">
        <span className="line" />
        <span className="divider-text">{this.props.children}</span>
        <span className="line" />
      </div>
    );
  }
}

export { SectionDivider };
